import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SupportService } from 'src/app/services/core/support/support.service';
import { SUPPORT_ROLE_LABELS, SUPPORT_SCOPE_BADGES } from 'src/app/utils/support.utils';
import { sweetAlert } from 'src/app/utils/swal';

// who a ticket on a reference is raised for, picked when it has more than one, e.g. the vendor, funding source and member of a trip
@UntilDestroy()
@Component({
  selector: 'app-raise-ticket-modal',
  templateUrl: './raise-ticket-modal.component.html',
  styleUrls: ['./raise-ticket-modal.component.css']
})
export class RaiseTicketModalComponent implements OnInit {
  @Input() referenceType = '';
  @Input() referenceId = '';
  @Output() closeModal = new EventEmitter<void>();

  tenants: any[] = [];

  constructor(private supportService: SupportService) { }

  ngOnInit(): void {
    this.supportService.getReferenceDetails(this.referenceType, this.referenceId).pipe(untilDestroyed(this)).subscribe((reference: any) => {
      this.tenants = (reference.tenants || []).map((tenant: any) => ({
        ...tenant,
        label: SUPPORT_ROLE_LABELS[tenant.type],
        badge: SUPPORT_SCOPE_BADGES.find((scope) => scope.type === tenant.type)?.badge,
        isSelected: false,
      }));
      // nothing to pick, e.g. only a vendor
      if (this.tenants.length <= 1) {
        this.tenants.forEach((tenant) => tenant.isSelected = true);
        this.onSubmit();
      }
    }, (err) => {
      sweetAlert('Error', err, 'error', 'OK');
      this.closeModal.emit();
    });
  }

  get selectedTenants() {
    return this.tenants.filter((tenant) => tenant.isSelected);
  }

  onSubmit() {
    const scope: any = {};
    this.selectedTenants.forEach((tenant) => scope[tenant.type] = tenant.id);
    this.supportService.raiseTicket(this.referenceType, this.referenceId, Object.keys(scope).length ? scope : undefined);
    this.closeModal.emit();
  }
}
